<template>
  <v-card>
    <v-card-text>
      <h3>Temperature</h3>
      <convert-box type="temperature"></convert-box>
    </v-card-text>
  </v-card>
</template>

<script>
import ConvertBox from '../components/ConvertBox'

export default {
  components: { ConvertBox },
  data() {
    return {
      unit: [
        {
          text: 'Celsius',
          val: 1
        },
        {
          text: 'Kelvin',
          val: 274.15
        },
        {
          text: 'Fahrenheit',
          val: 33.8
        }
      ]
    }
  },
  created() {
    this.$store.dispatch('setUnit', this.unit)
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// temperature.vue?6e08049b